'use client'

// Bottom CTA for /guarantee. The page is a static server component, so the
// plan-aware swap lives in this client island: visitors and FREE users get the
// "Get Pro" upsell, while PRO members (comp-aware via useEffectivePlan — the
// raw session plan is comp-blind) see a covered-state message instead of being
// asked to buy what they already have (founder report 2026-07-06).

import Link from 'next/link'
import { useSession } from 'next-auth/react'
import { useEffectivePlan } from '@/lib/billing/use-effective-plan'

export default function GuaranteeCta() {
  const { data: session } = useSession()
  const plan = useEffectivePlan((session?.user as { plan?: string } | undefined)?.plan)

  if (plan === 'PRO') {
    return (
      <div className="mt-10 text-center">
        <p className="text-sm font-semibold text-foreground">
          You&apos;re on Pro — the guarantee has you covered. 🎯
        </p>
        <p className="mt-2 text-xs text-muted-foreground">
          Keep practicing, and enter your official College Board score above once you get it. See
          how much students gain on our{' '}
          <Link href="/proof" className="underline underline-offset-2 hover:text-foreground">
            results page
          </Link>
          .
        </p>
      </div>
    )
  }

  return (
    <div className="mt-10 text-center">
      <Link
        href="/pricing"
        className="inline-flex h-11 items-center justify-center rounded-md bg-brand px-6 text-sm font-semibold text-on-brand transition hover:bg-brand-hover"
      >
        Get Pro &amp; start improving
      </Link>
      <p className="mt-3 text-xs text-muted-foreground">
        See how much students gain on our{' '}
        <Link href="/proof" className="underline underline-offset-2 hover:text-foreground">
          results page
        </Link>
        .
      </p>
    </div>
  )
}
